
let _modules = {};

function registerModule(module) {
    _modules[module.getId()] = module;
}

function unregisterModule(module) {
    _modules[module.getId()] = null;
}

function existsModule(id) {
    return !!getModule(id);
}

function getModule(id) {
    return _modules[id];
}

function getModules() {
    let modules = [];
    for (let id in _modules) {
        modules.push(_modules[id]);
    }
    return modules;
}

export {
    existsModule,
    getModule,
    getModules,
    registerModule,
    unregisterModule
};
